module.exports = __webpack_public_path__ + "static/media/tabbargetfans_N.ac3e22e5.png";